import { Box, Typography } from '@mui/material';

import dayjs from 'dayjs';
import { useIntl } from 'react-intl';
import ConsumptionRateDialog from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/components/consumption-rate-dialog';
import FeedInventoryDialog from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/components/feed-inventory-dialog';
import { useInputSettingsState } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/context/input-settings-context';

const PAGE_NAME_ID = 'orderFeed.ofdMySupplyPlan';

const InventoryConsumptionBox = () => {
  const intl = useIntl();
  const {
    getOfdSettingsQuery: { data: ofdSettings },
  } = useInputSettingsState();

  if (!ofdSettings) return null;

  return (
    <Box width={'100%'}>
      <Box display={'flex'} mb={2}>
        <Typography fontWeight={'bold'} width={'100%'}>
          {intl.formatMessage({ id: `${PAGE_NAME_ID}.todayLabel` })} ({dayjs().format('DD MMM')})
        </Typography>
      </Box>
      <>
        <FeedInventoryDialog />
        <ConsumptionRateDialog />
      </>
    </Box>
  );
};

export default InventoryConsumptionBox;
